import { request } from '../request';

export const envApi = {
  listEnvs: () => request('/envs'),

  saveEnvs: (envs) =>
    request('/envs', {
      method: 'PUT',
      body: JSON.stringify(envs)
    }),

  deleteEnv: (key) =>
    request(`/envs/${encodeURIComponent(key)}`, {
      method: 'DELETE'
    }),

  deleteEnvMulti: (keys) =>
    request('/envs/batch', {
      method: 'DELETE',
      body: JSON.stringify(keys),
      headers: {
        'Content-Type': 'application/json'
      }
    })
};
